import { render, staticRenderFns } from "./couponEditModal.vue?vue&type=template&id=4428a086&scoped=true"
import script from "./couponEditModal.vue?vue&type=script&lang=js"
export * from "./couponEditModal.vue?vue&type=script&lang=js"
import style0 from "./couponEditModal.vue?vue&type=style&index=0&id=4428a086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428a086",
  null
  
)

export default component.exports